const aeonik =
  "Aeonik, Noto Sans, Noto Sans Thai Looped, Noto Sans TC, Noto Sans SC, Noto Sans JP, Noto Sans Arabic, Noto Serif Georgian, sans-serif" as const

// Keep 'gotham' export name for backward compatibility with existing styled components
export const FontFamily = {
  gotham: aeonik
}
